import { useState } from "react"
import { useRoute } from "@hydrologiq/shared/providers/helpers/useRoute"
import { useNavigate } from "react-router-dom"
import Popover from "@hydrologiq/shared/chakra/Popover"
import SystemCreationForm from "@hydrologiq/shared/components/creation/SystemCreationForm"
import SystemsTable from "@hydrologiq/shared/system/SystemsTable"

interface CustomerSiteSystemsTableProps {
  customerId: string
  customerName?: string
  siteId: string
}

function CustomerSiteSystemsTable({ customerId, siteId }: CustomerSiteSystemsTableProps) {
  const route = useRoute()
  const navigate = useNavigate()
  const [createOpen, setCreateOpen] = useState(false)

  const systemLinkPrefix = `${route}${customerId}/sites/${siteId}/systems/`

  const createSystemButton = (
    <Popover
      actionType="createSystem"
      actionVariant="secondary"
      placement="right-end"
      loading={false}
      onOpenChange={setCreateOpen}
      open={createOpen}
    >
      <SystemCreationForm
        onSuccess={(system) => {
          setCreateOpen(false)
          navigate(`${systemLinkPrefix}${system.id}`)
        }}
        onCancel={() => setCreateOpen(false)}
        customerId={customerId}
        siteId={siteId}
        showCustomerSiteSelection={false}
      />
    </Popover>
  )

  return (
    <SystemsTable
      customerId={customerId}
      siteId={siteId}
      headerActions={createSystemButton}
      systemLinkPrefix={systemLinkPrefix}
      emptyStateText="No systems have assets deployed to this customer site"
    />
  )
}

export default CustomerSiteSystemsTable
